import app from '../appContext';

const ss = document.styleSheets;
let ctCSS;
export let backG;
let tempColor;
let origColor;

export function getDummyClass() {
    for (var i = 0, il = ss.length; i < il; i++) {
        if (ss[i].ownerNode.id === 'clientTemplate_style') {
            ctCSS = ss[i];
            break;
        }
    }

    if (ctCSS != null) {
        for(let rule of ctCSS.cssRules) {
            if (rule.selectorText === ".cont-dummy") {
                backG = rule.style;
                origColor = backG.backgroundColor;
                break;
            }
        }
    }
}

export function validateColor(e) {
    var clr = null;
    //catch error when saving a style in an expression builder, Bug 13264 ...MD
    if (typeof e === 'string') {
        //if this is a string use it.
        clr = validateColorC(e);

        if (clr != false) {
            return true;
        }
    } else {
        //if not a string, assume it is a control.
        clr = validateColorC(e.buf);
        if (clr != false) {
            e.buf = clr;
            return true;
        }
    }
    return false;
}

const VALIDATE_COLOR_REGEX = /(^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$)/;

/**
 * @param {string} color
 * @returns {boolean|string} - returns false if color didn't change, otherwise returns valid color
 */
export function validateColorC(color) {
    let clr;
    if (backG == null) {
        getDummyClass();
    }

    if (color.indexOf("#") === 0) {
        if (VALIDATE_COLOR_REGEX.test(color.substring(1))) {
            //evaluate it as a valid hex string
            clr = color;
        } else {
            clr = color.substring(1);
        }
    } else if(color.toLowerCase().indexOf("rgb") === 0){
        //evaluate it as a valid rgb string
        clr = color;
    } else if (VALIDATE_COLOR_REGEX.test(color)) {
        //if it is a hex string, add the #
        clr = "#" + color;
    } else {
        //Evaluate it as the name of a color
        clr = color;
    }

    tempColor = origColor;
    backG.backgroundColor = clr;
    if (backG.backgroundColor === tempColor) {
        //The value did not change;
        return false;
    }
    //The value did change, it was accepted;
    backG.backgroundColor = origColor;
    return clr.trim();
}

export function validateExpression(property, viewID, expression, mvc, expressionMessage) {
    if (viewID != null && mvc != null) {
        try {
            let exp = app.dv.helpers.expression.create(null, viewID, expression, mvc);
            exp.evaluate();
            return true;
        }
        catch (e) {
            if (expressionMessage != null) {
                app.browser.notifier.showToast(expressionMessage, 6000);
            }
            return false;
        }
    } else {
        try {
            let exp = app.dv.helpers.expression.create(null, 0, expression, null);
            // var values = exp.evaluate();
            //We cannot evaluate this. An expression might use an mvc and that fails incorrectly. Just check to see if the expression was created...KB
            return exp != null;
        }
        catch (e) {
            if (expressionMessage != null) {
                app.browser.notifier.showToast(expressionMessage, 6000);
            }
            return false;
        }
    }
}
